module.exports = __webpack_public_path__ + "static/img/bot_right.78f8c14a.png";